module.exports = __webpack_public_path__ + "img/Banner_2.9111a2b4.svg";